import {priority, odbcclient} from '@priority-software/priority-proto-api/lib';
import {getOdbcAdditionalProps} from '../../../services/proto/core/loginProps';
import {callServer, Options} from '../../../services/proto/core/server';
import {ServerMethods} from '../../../services/proto/core/constants';
import {SerializedReportParams} from '../types';
import {getServerStoreData} from '../../../services/proto/ServerStorage/service';
import {Action, getStorageKey, Namespace} from '../../../services/proto/ServerStorage/utils';
import {base64ToUtf8} from '../../../utils/base64';

export const treeNodeChildern = (
    ReportId: number | Long | null,
    NodeId: string,
    Mode: priority.netitems.nrest.TreeNodeChildrenModes,
    options?: Partial<Options>
): Promise<priority.netitems.nrest.ITreeNodeChildrenRs> => {
    return callServer(
        odbcclient.treeNodeChildren,
        new priority.netitems.nrest.TreeNodeChildrenRq({
            NodeId,
            ReportId,
            Mode,
            Properties: getOdbcAdditionalProps()
        }),
        ServerMethods.TreeNodeChildrenRq,
        options
    );
};

export const reportList = (
    RootNodeId: string,
    options?: Partial<Options>
): Promise<priority.netitems.nrest.IReportListRs> => {
    return callServer(
        odbcclient.reportList,
        new priority.netitems.nrest.ReportListRq({
            RootNodeId,
            Properties: getOdbcAdditionalProps()
        }),
        ServerMethods.ReportListRq,
        options
    );
};

export interface IReportSaveParams {
    RootNodeId: string;
    Title: string;
    General: boolean;
    Vertical: boolean;
    ReportId: number | Long;
    Columns: priority.netitems.nrest.IReportCol[];
    CopyOfReportId?: number | Long;
    InUse: boolean;
    LinkId: string;
    ReportType: priority.netitems.nrest.RepType;
    Tabular?: boolean;
    OuterJoin?: number;
    ConnectId?: number;
}
export const reportSave = (
    params: IReportSaveParams,
    options?: Partial<Options>
): Promise<priority.netitems.nrest.IReportSaveRs> => {
    return callServer(
        odbcclient.reportSave,
        new priority.netitems.nrest.ReportSaveRq({
            ...params,
            Properties: getOdbcAdditionalProps()
        }),
        ServerMethods.ReportSaveRq,
        options
    );
};

export const reportData = (
    ReportId: number | Long | null,
    options?: Partial<Options>
): Promise<priority.netitems.nrest.IReportDataRs> => {
    return callServer(
        odbcclient.reportData,
        new priority.netitems.nrest.ReportDataRq({
            ReportId,
            Properties: getOdbcAdditionalProps()
        }),
        ServerMethods.ReportDataRq,
        options
    );
};

export const reportDel = (
    ReportId: number | Long | null,
    options?: Partial<Options>
): Promise<priority.netitems.nrest.IReportDelRs> => {
    return callServer(
        odbcclient.reportDel,
        new priority.netitems.nrest.ReportDelRq({
            ReportId,
            Properties: getOdbcAdditionalProps()
        }),
        ServerMethods.ReportDelRq,
        options
    );
};

export const datesFormats = (
    options?: Partial<Options>
): Promise<priority.netitems.nrest.IDateFormatsRs> => {
    return callServer(
        odbcclient.dateFormats,
        new priority.netitems.nrest.DateFormatsRq({
            Properties: getOdbcAdditionalProps()
        }),
        ServerMethods.DateFormatsRq,
        options
    );
};

export const generateReportsColumns = (
    NodeId: string[] | null,
    ReportId: number | Long,
    LinkId: string,
    options?: Partial<Options>
): Promise<priority.netitems.nrest.IReportColumnsRs> => {
    return callServer(
        odbcclient.reportColumns,
        new priority.netitems.nrest.ReportColumnsRq({
            NodeId,
            ReportId,
            LinkId,
            Properties: getOdbcAdditionalProps()
        }),
        ServerMethods.ReportColumnsRq,
        options
    );
};

export const getNumericFormats = (): Promise<priority.netitems.nrest.INumericFormatsRs> => {
    return callServer(
        odbcclient.NumericFormats,
        new priority.netitems.nrest.NumericFormatsRq({
            Properties: getOdbcAdditionalProps()
        }),
        ServerMethods.NumericFormatsRq
    );
};

export const cancelReport = (LinkId: string): Promise<priority.netitems.nrest.IReportCancelRs> => {
    return callServer(
        odbcclient.cancelReport,
        new priority.netitems.nrest.ReportCancelRq({
            LinkId: LinkId,
            Properties: getOdbcAdditionalProps()
        }),
        ServerMethods.ReportCancelRq
    );
};

export const getChartData = async (
    reportId: number,
    serializedReportParams: SerializedReportParams[]
) => {
    const res = await callServer(
        odbcclient.getReportData,
        new priority.netitems.nrest.DataRq({
            ReportId: reportId,
            Properties: getOdbcAdditionalProps(),
            Inputs: serializedReportParams
        }),
        ServerMethods.DataRq
    );
    return res;
};

export const getOuterJoinMapFromServer = async reportId => {
    const key = getStorageKey({
        nameSpace: Namespace.Analytics,
        action: Action.onOuterJoinSave,
        storage: reportId
    });
    const data = await getServerStoreData([key], false, false);
    if (data[key]?.Str) {
        const decodedMap = JSON.parse(base64ToUtf8(data[key]?.Str));
        return decodedMap;
    } else {
        return null;
    }
};
